import { Item } from 'baseui/side-navigation';
import { Key } from 'react';
import { useRecoilValue } from 'recoil';
import {
  CORE_PAGE_IDS,
  FLEET_PAGE_IDS,
  FLEET_SECTION_ID,
  OTHER_All_WORKSPACES_PAGE_IDS,
  OTHER_PAGE_IDS,
  ZONE_PAGE_IDS,
  ZONE_SECTION_ID,
} from '../constants/app';
import { isAllWorkspacesSelect, pageState } from '../storage/app';
import { SidenavBlock } from '../types/app';
import { getPageNavKey } from '../utils/pages';

export function useSidenavItems(items: Item[]) {
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const currentPage = useRecoilValue(pageState);

  const coreItems = items.filter((item) => item.itemId && CORE_PAGE_IDS.includes(item.itemId));
  const fleetItems = items.filter((item) => item.itemId && FLEET_PAGE_IDS.includes(item.itemId));
  const zoneItems = items.filter((item) => item.itemId && ZONE_PAGE_IDS.includes(item.itemId));
  const otherItems = items.filter((item) =>
    item.itemId
      ? isAllWorkspacesSelected
        ? OTHER_All_WORKSPACES_PAGE_IDS.includes(item.itemId)
        : OTHER_PAGE_IDS.includes(item.itemId)
      : false
  );

  const pageSection: Key | undefined = (() => {
    const navKey = getPageNavKey(currentPage) ?? '';
    if (FLEET_PAGE_IDS.includes(navKey)) {
      return FLEET_SECTION_ID;
    }
    if (ZONE_PAGE_IDS.includes(navKey)) {
      return ZONE_SECTION_ID;
    }
  })();

  const mixedNav: SidenavBlock[] = [
    {
      type: 'flat',
      items: coreItems,
    },
  ];

  if (!isAllWorkspacesSelected) {
    mixedNav.push({
      type: 'section',
      id: FLEET_SECTION_ID,
      title: 'Flota Segura',
      items: fleetItems,
    });
    mixedNav.push({
      type: 'section',
      id: ZONE_SECTION_ID,
      title: 'Lugares',
      items: zoneItems,
    });
  }

  mixedNav.push({
    type: 'flat',
    items: otherItems,
  });

  return {
    pageSection,
    navigationBlocks: mixedNav.filter((block) => block.items.length > 0),
  };
}
